import { render, staticRenderFns } from "./PropertyDetailsContent.vue?vue&type=template&id=0d389cb4&scoped=true&"
import script from "./PropertyDetailsContent.vue?vue&type=script&lang=js&"
export * from "./PropertyDetailsContent.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetailsContent.vue?vue&type=style&index=0&id=0d389cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d389cb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VLayout,VProgressCircular,VRow})
